export const GET_DEMO_DATA = "GET_DEMO_DATA";
export const GET_DEMO_DATA_SUCCESS = "GET_DEMO_DATA_SUCCESS";
export const GET_DEMO_DATA_FAIL = "GET_DEMO_DATA_FAIL";